import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/legal/PrivacyPolicy";
import TermsOfUse from "../pages/legal/TermsOfUse";
import RefundPolicy from "../pages/legal/RefundPolicy";
import DeliveryPolicy from "../pages/legal/DeliveryPolicy";
import CookiePolicy from "../pages/legal/CookiePolicy";
import Auth from "../pages/auth/page";
import ResetPassword from "../pages/auth/ResetPassword";
import Profile from "../pages/profile/page";
import OrderDetailPage from "../pages/orders/page";
import Generate from "../pages/generate/page";
import PricingPage from "../pages/pricing/page";
import CheckoutPage from "../pages/checkout/page";
import PaymentMethodPage from "../pages/checkout/payment-method/page";
import PaymentResultPage from "../pages/payment-result/page";
import GatewayPayPage from "../pages/gateway-pay/page";
import PayHostFallback from "../pages/gateway-pay/PayHostFallback";

export const appRoutes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/auth",
    element: <Auth />,
  },
  {
    path: "/auth/reset",
    element: <ResetPassword />,
  },
  {
    path: "/profile",
    element: <Profile />,
  },
  {
    path: "/orders/:orderId",
    element: <OrderDetailPage />,
  },
  {
    path: "/generate",
    element: <Generate />,
  },
  {
    path: "/pricing",
    element: <PricingPage />,
  },
  {
    path: "/checkout",
    element: <CheckoutPage />,
  },
  {
    path: "/checkout/payment-method",
    element: <PaymentMethodPage />,
  },
  {
    path: "/pay/:paymentId",
    element: <GatewayPayPage />,
  },
  {
    path: "/payment-result",
    element: <PaymentResultPage />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-use",
    element: <TermsOfUse />,
  },
  {
    path: "/refund-policy",
    element: <RefundPolicy />,
  },
  {
    path: "/delivery-policy",
    element: <DeliveryPolicy />,
  },
  {
    path: "/cookie-policy",
    element: <CookiePolicy />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

/** pay.aistyle.com only serves the bank picker. Everything else points home. */
export const payHostRoutes: RouteObject[] = [
  {
    path: "/pay/:paymentId",
    element: <GatewayPayPage />,
  },
  {
    path: "*",
    element: <PayHostFallback />,
  },
];

export default appRoutes;